var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Cambiar privacidad a expediente #" + _vm.file.numero,
        size: "lg",
        "hide-footer": "",
        centered: "",
        "no-close-on-backdrop": ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("b-overlay", { attrs: { show: _vm.loading } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 text-center" },
            [
              _c("h3", [
                _vm._v(" ¿Deseas cambiar la privacidad del expediente a "),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.file.transportePuertoTipo === "0"
                        ? "Público"
                        : "Privado"
                    )
                  )
                ]),
                _vm._v("? ")
              ]),
              _c("b-form-select", {
                staticClass: "mt-3",
                attrs: { options: _vm.optionsIsPrivate },
                model: {
                  value: _vm.privacity,
                  callback: function($$v) {
                    _vm.privacity = $$v
                  },
                  expression: "privacity"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 text-right  mt-5" },
            [
              _c(
                "b-button",
                {
                  attrs: { "data-cy": "send-docdigital", variant: "primary" },
                  on: { click: _vm.send }
                },
                [_vm._v(" Confirar ")]
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }